import React from 'react';
import { 
  IoLogoLinkedin,
  IoLogoGithub,
  IoLogoInstagram,
  IoMdCall,
} from 'react-icons/io';

function Footer() {
  return (
    <footer className='bg-grey-default pt-4 pb-4 pl-5 pr-5 md:pl-12 md:pr-12'>
      <section className='flex flex-col md:flex-row justify-center items-center'>
        <div className="social_media flex text-white gap-2">
          <a href="tel:+250786021869" className="hover:text-orange-100">
            <IoMdCall size="24" />
          </a>
          <a href="https://www.instagram.com/ann__leslie" target="_blank" rel="noopener noreferrer" className="hover:text-orange-100">
            <IoLogoInstagram size="24" />
          </a>
          <a href="https://www.linkedin.com/in/uhiriwe-anne-leslie-040552256" target="_blank" rel="noopener noreferrer" className="hover:text-orange-100">
            <IoLogoLinkedin size="24" />
          </a>
          <a href="https://github.com/A-Leslie" target="_blank" rel="noopener noreferrer" className="hover:text-orange-100">
            <IoLogoGithub size="24" />
          </a>
        </div>
        <div className="copy mt-2 md:mt-0 md:pl-5">
          <p className='text-white text-center md:text-left'> Copyright 2023 All rights reserved </p>
        </div>
      </section>
    </footer>
  );
}

export default Footer;
